import httpService from "core/infrastructure/http";
import { ApplicationState } from "core/app";
import { PageList } from "core/pages/pageList";
import { MultiSelectItem } from "components/multiselect";


export const mapUpTo = <T>(n: number, fn: (idx: number) => T) => {
    var arr = [];
    for (var i = 0; i < n; i++) {
        arr.push(fn(i));
    }
    return arr;
};

export const makePageChange = (pageNumber: number, applicationState: ApplicationState, data: any, setPageNumber: (num: number) => void, makeRequest: (skip: number, take: number) => void) => {
    setPageNumber(pageNumber);
    const rows = applicationState.maxRows * pageNumber;
    if (data.skip > rows || rows >= data.take) {
        let skip = Math.floor(pageNumber / 10) * applicationState.pageSize;
        makeRequest(skip, skip + applicationState.pageSize);
    }
}

export const makeRequest = async <T> (skip: number, take: number, applicationState: ApplicationState, initialData: T, search: any, senderId: string, page_config: PageList, setLoading: (loading: boolean) => void, setError: (error: string) => void, setData: (data: T) => void) => {
    setLoading(true);
    setData(initialData);
    const response = await httpService.apiPost<T>({
        applicationState: applicationState,
        route: applicationState.apiService + "/" + page_config.apiType + "/" + page_config.apiUrl,
        query: {
            FromUtc: applicationState.selectedDate.toISOString(),
            ToUtc: page_config.getDefaultToDateTime(applicationState).toISOString(),
            Filter: search,
            Skip: skip,
            Take: take
        },
        senderId: senderId
    })();

    if (response.ok) {
        setData(response.data);
        setError("");
    } else {
        setError(response.error || "An unknown error occured."); //TODO
    }
    setLoading(false);
}

export const handleMultiSelectChange = (selectedItems: MultiSelectItem[], itemKey: string, selectedItem: MultiSelectItem, special: string) => {
    const newList = selectedItems.map((item) => {
        if (special === "ALL") {
            return { ...item, selected: true };
        }
        if (special === "NONE") {
            return { ...item, selected: false };
        }
        if (item.id === selectedItem.id) {
            return { ...item, selected: !item.selected };
        }
        return item;
    });
    localStorage.setItem(itemKey, JSON.stringify(newList));
    localStorage.setItem('lastSavedOn', new Date().toISOString());
    return newList;
}

export const filterSelectedItems = (selectedItems: MultiSelectItem[], availableColumns: string[], itemKey: string, itemMap: (item: MultiSelectItem) => any) => {
    return [
        ...selectedItems,
        ...availableColumns
            .filter((value, index, self) => self.indexOf(value) === index) // =distinct
            .filter(k => k.toLowerCase().startsWith(itemKey) && selectedItems.filter(s => s.id.toLowerCase() === k.toLowerCase().replace(itemKey, "")).length === 0)
            .map((key) => {
                return {
                    isDisplayed: false,
                    id: key.toLowerCase().replace(itemKey, "").toUpperCase(),
                    text: key.toLowerCase().replace(itemKey, "").toUpperCase(),
                    selected: true
                };
            })
    ].map((item) => itemMap(item)).sort((a, b) => a.id.localeCompare(b.id)) 
}

export function mapTranslations(allTranslations: any): MultiSelectItem[] {
    return Object.keys(allTranslations).map((k) => {
        return {
            id: k,
            text: allTranslations[k],
            selected: true,
            isDisplayed: true
        };
    })
}
